import { useMemo } from "react";
import { useCurrentBlock } from "../store/hooks";

export const BSC_BLOCK_TIME = 3;

const BlockTimestamp = ({ startStakeBlock }) => {
  const currentBlock = useCurrentBlock();
  const result = useMemo(() => {
    if (currentBlock == null) return { formattedDate: "Loading..." };

    const startBlockAsNumber = Number(startStakeBlock);
    if (currentBlock < startBlockAsNumber)
      return { formattedDate: "Loading..." };

    const blockDiff = currentBlock - startBlockAsNumber;
    const stakeTimestamp = Date.now() - blockDiff * BSC_BLOCK_TIME * 1000;
    const date = new Date(stakeTimestamp);

    const formattedDateStr = date
      .toUTCString()
      .split(" ")
      .slice(1, 3)
      .join("-")
      .concat(`-${date.getUTCFullYear()}`)
      .concat(
        ` ${date.getUTCHours()}:${String(date.getUTCMinutes()).padStart(
          2,
          "0"
        )}`
      );

    return { formattedDate: formattedDateStr };
  }, [startStakeBlock, currentBlock]);

  return <p className="mb-0">{result.formattedDate}</p>;
};

export default BlockTimestamp;
